document.querySelectorAll("[data-btn='menu']").forEach(item => {
  item.addEventListener("click", function (e) {
    document.querySelector('.headerBurger').classList.add('active')
  })
});

document.querySelectorAll(".headerBurger__close").forEach(item => {
  item.addEventListener('click', function (e) {
    document.querySelector('.headerBurger').classList.remove('active')
  })
})

document.querySelectorAll("[data-btn='city']").forEach(item => {
  item.addEventListener('click', function (e) {
    document.querySelector('.headerBurger').classList.remove('active')
    document.querySelector('.headerCity').classList.add('active')
  })
})

document.querySelectorAll(".headerBurger__closeCity").forEach(item => {
  item.addEventListener('click', function (e) {
    document.querySelector('.headerCity').classList.remove('active')
  })
})
